export default __webpack_public_path__ + "static/media/trans face 2 (1).64bc0082.png";